import script from "./expoundAnswer.vue?vue&type=script&setup=true&lang=js"
export * from "./expoundAnswer.vue?vue&type=script&setup=true&lang=js"

import "./expoundAnswer.vue?vue&type=style&index=0&id=0f8a0b32&scoped=true&lang=scss"

import exportComponent from "D:\\Projects\\learning-center\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f8a0b32"]])

export default __exports__